import { setup_main_nav } from './deep-fried-modules/_main_nav';
import { setup_sticky_nav } from './_sticky-nav';
import { woo_sidebar } from './_woo-sidebar';
import { setup_retina_assets } from './deep-fried-modules/_retina';
import { setup_acf_google_maps } from './deep-fried-modules/_acf_google_maps';

jQuery( document ).ready( ( $ ) =>
{
	setup_main_nav();
	setup_retina_assets();
	setup_acf_google_maps();
	woo_sidebar();
	setup_sticky_nav();
} );
